import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeHistoryNf3eResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeHistoryNf3eResponse(value));

const isHistoryNf3eAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleHistoryNf3eError = (xhr, reject, rejectMessage) => {
  if (isHistoryNf3eAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const ajaxHistoryNf3eEvent = ({
  type,
  pp,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'erro',
  extraData = {},
  routeField = 'll',
  encodeRoute = true,
  encodeDd = true,
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode(pp),
        [routeField]: encodeRoute ? base64_encode(ll) : ll,
        ...(encodeDd ? { dd: base64_encode(JSON.stringify(dd)) } : {}),
        tk,
        ...extraData,
      },
      success: function (data) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        handleHistoryNf3eError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});

const RestHistoryNf3ePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'deleteMarcador':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'deleteMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downXML':
      return ajaxHistoryNf3eEvent({
        type: 'Get',
        pp: 'nf3e',
        ll: 'dwnXml',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLote':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'downloadLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLoteTodas':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'downloadLoteTodas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmail':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'enviaArquivosEmail',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmailTodos':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'enviaArquivosEmailTodos',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'eventos':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 1 },
      });
    case 'hideMarcador':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'hideMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'investigar':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'investigar',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'manifestacao':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'manifestacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'pesqNf3e':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'pesqNf3e',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'printDanfe':
      return ajaxHistoryNf3eEvent({
        type: 'Get',
        pp: 'nf3e',
        ll: 'printDanfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'salvaConfigTabela':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'updateConfigTabela',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost, null, 2))],
        tk: token,
        extraData: { cf: Arr_.dataPost },
      });
    case 'salvaNovoMarcador':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'salvaNovoMarcadorNf3e',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: { tipo: 'nf3e' },
      });
    case 'setMarcador':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'setMarcador',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'showMarcador':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'showMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'situacao':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 0 },
      });
    case 'updateAnotacao':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'updateAnotacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadXmlsNfce':
      return ajaxHistoryNf3eEvent({
        type: 'Post',
        pp: 'nf3e',
        ll: 'downloadXmlsNf3e',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'raw',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestHistoryNf3eGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'getConfigTableNf3e':
      return ajaxHistoryNf3eEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'getConfigTableNfce',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
      });
    case 'getItensNf3e':
      return ajaxHistoryNf3eEvent({
        type: 'Get',
        pp: 'nf3e',
        ll: 'getItensNf3e',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getMarcadores':
      return ajaxHistoryNf3eEvent({
        type: 'Get',
        pp: 'nf3e',
        ll: 'getMarcadores',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getVinculados':
      return ajaxHistoryNf3eEvent({
        type: 'Get',
        pp: 'nf3e',
        ll: 'getVinculadosNf3e',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestHistoryNf3ePost, RestHistoryNf3eGet };